var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJuara3New(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1889_15016",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.0007,
    r: 12,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1889_15016)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.0007,
    r: 12,
    fill: "#F0F2F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.21598 18.1539L8.19848 18.1764C8.09636 18.2927 7.97234 18.3879 7.83348 18.4564C7.71508 18.5108 7.58629 18.5389 7.45598 18.5389C7.39131 18.5384 7.32685 18.5317 7.26348 18.5189L7.70598 17.7514C7.85321 17.546 7.95216 17.3101 7.99545 17.0612C8.03874 16.8123 8.02525 16.5568 7.95598 16.3139C7.84848 15.9989 7.65098 15.9614 7.58348 15.9489H7.55848C6.33458 15.6133 5.20618 14.996 4.26348 14.1464C4.11598 14.0139 3.97348 13.8789 3.83598 13.7364C3.69848 13.5939 3.54098 13.4039 3.40098 13.2364C3.08403 12.8563 2.7989 12.4507 2.54848 12.0239C1.82544 10.7906 1.39203 9.40914 1.28098 7.98386L1.25098 7.62886L1.42598 7.51636L5.12598 7.62886L5.11098 7.97136C5.11098 7.97136 5.08098 8.90636 5.61098 9.47136C5.73283 9.60272 5.87993 9.70815 6.04348 9.78136C6.27249 9.88023 6.51904 9.93209 6.76848 9.93386L6.94348 10.6489C6.63857 10.6252 6.33696 10.5699 6.04348 10.4839C5.69383 10.3799 5.37807 10.1849 5.12848 9.91886C4.73384 9.45892 4.49878 8.88355 4.45848 8.27886H1.95848C2.05116 9.05126 2.24621 9.8079 2.53848 10.5289C2.7672 11.0974 3.05636 11.6396 3.40098 12.1464C3.53848 12.3514 3.68598 12.5464 3.83848 12.7339C3.99098 12.9214 4.11598 13.0639 4.26598 13.2189C5.2068 14.212 6.40034 14.9302 7.71848 15.2964C7.77371 15.3072 7.82803 15.3222 7.88098 15.3414C8.04775 15.4037 8.19777 15.5038 8.31925 15.634C8.44072 15.7641 8.53031 15.9207 8.58098 16.0914C8.68554 16.4398 8.70698 16.8078 8.64359 17.166C8.58021 17.5242 8.43375 17.8625 8.21598 18.1539Z",
    fill: "url(#paint0_linear_1889_15016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74992 8.07167L4.46742 8.28667H2.02742L1.91992 7.89917L4.74992 8.07167Z",
    fill: "#6D6D6D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2152 18.1531L8.1977 18.1756C8.09558 18.292 7.97155 18.3871 7.8327 18.4556C7.71429 18.51 7.58551 18.5382 7.4552 18.5381C7.39053 18.5376 7.32606 18.531 7.2627 18.5181L7.4377 18.4056L8.2152 18.1531Z",
    fill: "#6D6D6D"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37078 18.0639C8.26815 18.1811 8.14212 18.2757 8.00078 18.3414C7.88352 18.3968 7.7555 18.4258 7.62578 18.4264C7.56112 18.4259 7.49665 18.4192 7.43328 18.4064L7.87578 17.6289C8.02285 17.4235 8.1217 17.1875 8.16498 16.9387C8.20827 16.6898 8.19487 16.4343 8.12578 16.1914C8.02578 15.8764 7.82828 15.8389 7.75078 15.8264H7.72578C6.50189 15.4908 5.37348 14.8735 4.43078 14.0239C4.28328 13.8914 4.14078 13.7539 4.00328 13.6139C3.86578 13.4739 3.71578 13.2914 3.57578 13.1239C3.25883 12.7438 2.9737 12.3382 2.72328 11.9114C2.00056 10.6778 1.56639 9.29659 1.45328 7.87136L1.42578 7.51636H5.30078L5.28578 7.85886C5.28578 7.85886 5.25578 8.79386 5.78578 9.35886C5.90717 9.49074 6.05439 9.59626 6.21828 9.66886C6.44721 9.76799 6.69381 9.81986 6.94328 9.82136L6.92828 10.4764C6.68804 10.4725 6.44934 10.4372 6.21828 10.3714C5.86801 10.2674 5.55203 10.0715 5.30328 9.80386C4.90867 9.34368 4.67285 8.7686 4.63078 8.16386H2.13078C2.22453 8.93606 2.41954 9.69256 2.71078 10.4139C2.94067 10.9831 3.23065 11.5262 3.57578 12.0339C3.71328 12.2364 3.85828 12.4339 4.01328 12.6214C4.16828 12.8089 4.29078 12.9514 4.44078 13.1039C5.38146 14.0977 6.57497 14.8168 7.89328 15.1839C7.94797 15.1935 8.00157 15.2086 8.05328 15.2289C8.22081 15.2903 8.37162 15.3902 8.49361 15.5204C8.61561 15.6507 8.70539 15.8077 8.75578 15.9789C8.86171 16.332 8.88204 16.7053 8.81509 17.0679C8.74814 17.4304 8.59584 17.7718 8.37078 18.0639Z",
    fill: "url(#paint1_linear_1889_15016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37098 18.0623C8.26834 18.1796 8.14231 18.2741 8.00098 18.3398C8.67848 17.1298 8.31098 15.8398 8.04848 15.2273C8.21601 15.2888 8.36682 15.3886 8.48881 15.5189C8.6108 15.6491 8.70059 15.8061 8.75098 15.9773C8.8576 16.3301 8.87874 16.7031 8.81267 17.0657C8.74659 17.4282 8.59519 17.7698 8.37098 18.0623Z",
    fill: "#6D6D6D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22852 9.67651C6.45745 9.77565 6.70405 9.82752 6.95352 9.82901L6.93852 10.484C6.69828 10.4802 6.45958 10.4449 6.22852 10.379V9.67651Z",
    fill: "#6D6D6D"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6756 7.62808L22.6456 7.98308C22.5459 9.26201 22.187 10.5073 21.5906 11.6431C21.4731 11.8656 21.3406 12.0781 21.2181 12.2881C21.0956 12.4981 20.9481 12.6931 20.8031 12.8881C20.5669 13.1996 20.3106 13.4952 20.0356 13.7731C19.0255 14.8058 17.7589 15.5513 16.3656 15.9331H16.3406C16.2731 15.9331 16.0756 15.9831 15.9656 16.2981C15.8504 16.7155 15.894 17.1609 16.0881 17.5481C16.1256 17.6174 16.1699 17.6828 16.2206 17.7431L16.9231 18.4081L16.6731 18.5206C16.6098 18.5335 16.5453 18.5401 16.4806 18.5406C16.3807 18.5446 16.2809 18.5311 16.1856 18.5006C16.091 18.467 16.0017 18.4198 15.9206 18.3606C15.8511 18.3084 15.7867 18.2498 15.7281 18.1856C15.5042 17.8925 15.3528 17.5506 15.2863 17.1877C15.2198 16.8249 15.2402 16.4515 15.3456 16.0981C15.3984 15.9186 15.4944 15.7548 15.6252 15.621C15.7559 15.4872 15.9174 15.3875 16.0956 15.3306L16.1981 15.3056C17.701 14.8863 19.0377 14.0132 20.0256 12.8056C20.3098 12.4639 20.5664 12.1003 20.7931 11.7181C20.9448 11.462 21.0833 11.1983 21.2081 10.9281C21.3493 10.6158 21.4736 10.2962 21.5806 9.97058C21.7559 9.4243 21.879 8.86261 21.9481 8.29308H19.4481C19.4078 8.89777 19.1728 9.47314 18.7781 9.93308C18.5275 10.202 18.2087 10.3981 17.8556 10.5006C17.6304 10.5655 17.3975 10.6 17.1631 10.6031L17.1481 9.94808C17.3911 9.94605 17.6314 9.8968 17.8556 9.80308C18.0271 9.72898 18.1812 9.62 18.3081 9.48308C18.8406 8.91558 18.8081 7.98308 18.8081 7.98308L18.7931 7.64058L19.0431 7.52808L22.6756 7.62808Z",
    fill: "url(#paint2_linear_1889_15016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2627 8.13448L21.9552 8.28448H19.4727V7.96948L22.2627 8.13448Z",
    fill: "#6D6D6D"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9352 7.51636L22.9052 7.87136C22.8042 9.1504 22.4444 10.3956 21.8477 11.5314C21.7302 11.7539 21.5977 11.9664 21.4752 12.1764C21.3527 12.3864 21.2052 12.5814 21.0602 12.7764C20.8248 13.0878 20.5693 13.3834 20.2952 13.6614C19.2846 14.6936 18.0182 15.439 16.6252 15.8214H16.5977C16.5327 15.8339 16.3352 15.8714 16.2252 16.1864C16.1099 16.6038 16.1536 17.0492 16.3477 17.4364C16.3836 17.5074 16.4281 17.5737 16.4802 17.6339L16.9227 18.4114C16.8592 18.4239 16.7948 18.4306 16.7302 18.4314C16.6323 18.4318 16.5351 18.4158 16.4427 18.3839C16.3476 18.35 16.2583 18.302 16.1777 18.2414C16.1079 18.1914 16.0441 18.1335 15.9877 18.0689C15.762 17.7757 15.6093 17.433 15.5424 17.0691C15.4754 16.7052 15.4961 16.3307 15.6027 15.9764C15.6564 15.7954 15.7542 15.6306 15.8873 15.4966C16.0204 15.3627 16.1845 15.2638 16.3652 15.2089C16.3978 15.1979 16.4312 15.1895 16.4652 15.1839C17.9686 14.7643 19.306 13.8913 20.2952 12.6839C20.5785 12.343 20.8343 11.9802 21.0602 11.5989C21.2123 11.3422 21.3508 11.0776 21.4752 10.8064C21.6189 10.496 21.7433 10.1771 21.8477 9.85136C22.0256 9.30494 22.1487 8.74216 22.2152 8.17136H19.7152C19.6743 8.77638 19.4384 9.35185 19.0427 9.81136C18.7901 10.0834 18.4675 10.2807 18.1102 10.3814C17.8857 10.4461 17.6537 10.4805 17.4202 10.4839L17.4052 9.82886C17.6473 9.82657 17.8867 9.77733 18.1102 9.68386C18.2827 9.61045 18.4377 9.5014 18.5652 9.36386C19.0977 8.79636 19.0652 7.86386 19.0652 7.86386L19.0502 7.52136L22.9352 7.51636Z",
    fill: "url(#paint3_linear_1889_15016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1766 18.2353C16.1068 18.1853 16.043 18.1274 15.9866 18.0628C15.7617 17.7702 15.6095 17.4283 15.5426 17.0654C15.4756 16.7025 15.4958 16.3288 15.6016 15.9753C15.6554 15.7943 15.7532 15.6295 15.8862 15.4955C16.0193 15.3616 16.1835 15.2627 16.3641 15.2078C16.0766 15.7503 15.5966 16.9803 16.1766 18.2353Z",
    fill: "#6D6D6D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1093 9.68433V10.3818C17.8849 10.4465 17.6528 10.481 17.4193 10.4843L17.4043 9.82933C17.6465 9.82704 17.8859 9.77779 18.1093 9.68433Z",
    fill: "#6D6D6D"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7223 7.07886C17.7223 7.35886 17.7223 7.65136 17.7023 7.95636C17.7023 8.08386 17.7023 8.20636 17.6823 8.34886C17.5691 10.4403 17.1859 12.5082 16.5423 14.5014C15.6623 17.0539 14.2523 19.0939 12.1423 19.0939C8.36727 19.0939 6.81227 12.5514 6.58977 8.15386C6.58977 8.08886 6.58977 8.02136 6.58977 7.95636C6.58977 7.65136 6.57227 7.35886 6.57227 7.07886H17.7223Z",
    fill: "url(#paint4_linear_1889_15016)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6901 12.1164C13.551 11.9801 13.3786 11.8827 13.1901 11.8339C13.1441 11.8204 13.0974 11.8096 13.0501 11.8014V11.7664C13.1509 11.738 13.2488 11.7004 13.3426 11.6539C13.4438 11.6033 13.5372 11.5385 13.6201 11.4614C13.7005 11.3848 13.7641 11.2924 13.8071 11.19C13.8502 11.0876 13.8716 10.9775 13.8701 10.8664C13.8643 10.7299 13.8254 10.5968 13.7565 10.4787C13.6877 10.3607 13.5911 10.2612 13.4751 10.1889C13.1575 10.0125 12.7947 9.93421 12.4326 9.96392C12.0245 9.95823 11.6185 10.0234 11.2326 10.1564C11.2326 10.1889 11.0926 10.2989 11.0926 10.3314C11.0913 10.3497 11.0913 10.3681 11.0926 10.3864V10.4264C11.0926 10.6764 11.1951 10.8689 11.1851 11.1289C11.2733 11.1501 11.3543 11.1941 11.4201 11.2564C11.4855 11.3146 11.5662 11.3527 11.6526 11.3664C11.6751 11.3664 11.7701 11.1939 11.7926 11.1939V11.1364L11.8901 10.7239L11.9076 10.6489C11.9084 10.6392 11.9115 10.6297 11.9167 10.6214C11.9219 10.6132 11.9291 10.6063 11.9376 10.6014H11.9501C12.0477 10.5356 12.1624 10.5 12.2801 10.4989C12.3592 10.4893 12.4395 10.4973 12.5151 10.5224C12.5907 10.5475 12.6599 10.589 12.7176 10.6439C12.7947 10.7334 12.8357 10.8484 12.8326 10.9664C12.838 11.0497 12.823 11.133 12.7891 11.2092C12.7551 11.2854 12.7031 11.3522 12.6376 11.4039C12.52 11.4896 12.3838 11.5461 12.2401 11.5689C12.0539 11.6049 11.8647 11.6224 11.6751 11.6214C11.6751 11.6214 11.6751 11.6214 11.6751 11.6389C11.6751 11.6564 11.5426 11.7739 11.5426 11.7939C11.5426 11.9464 11.6801 12.0239 11.7001 12.1664C11.7001 12.1664 11.7001 12.1789 11.7001 12.1839H12.0376C12.1017 12.18 12.166 12.18 12.2301 12.1839C12.6126 12.2339 12.8751 12.4339 12.8751 12.7914V12.8289C12.8686 12.9167 12.843 13.002 12.8001 13.0789C12.7814 13.1145 12.7578 13.1473 12.7301 13.1764L12.7001 13.2039L12.6751 13.2264C12.5232 13.3275 12.3422 13.3758 12.1601 13.3639C12.0741 13.3614 11.9893 13.3427 11.9101 13.3089C11.8991 13.3035 11.8894 13.2958 11.8816 13.2863C11.8738 13.2769 11.8682 13.2658 11.8651 13.2539L11.7276 12.6839H11.7076L11.2476 12.7564L11.0976 12.7839C11.0976 12.8164 10.9526 12.9289 10.9551 12.9589C10.9901 13.2739 11.1801 13.5139 11.2251 13.8339C11.2969 13.8491 11.3695 13.86 11.4426 13.8664C11.6426 13.8898 11.8438 13.9007 12.0451 13.8989C12.1601 13.8989 12.2701 13.8989 12.3751 13.8989C12.6742 13.8957 12.9704 13.8398 13.2501 13.7339C13.3201 13.7033 13.3864 13.6647 13.4476 13.6189C13.4826 13.5939 13.5176 13.5664 13.5526 13.5364L13.5701 13.5214C13.6026 13.4939 13.6301 13.4664 13.6601 13.4364C13.7354 13.3641 13.798 13.2796 13.8451 13.1864C13.9206 13.0423 13.9584 12.8815 13.9551 12.7189C13.9545 12.6057 13.9307 12.4938 13.8851 12.3902C13.8395 12.2866 13.7731 12.1934 13.6901 12.1164Z",
    fill: "#5D2A14"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5881 12.3297C13.4029 12.1397 13.1605 12.0159 12.8981 11.9772V11.9422C12.9937 11.9137 13.0873 11.8786 13.1781 11.8372C13.3538 11.7563 13.503 11.6271 13.6081 11.4647C13.685 11.3382 13.7249 11.1927 13.7231 11.0447C13.7173 10.9078 13.6783 10.7744 13.6095 10.656C13.5407 10.5375 13.4441 10.4375 13.3281 10.3647C13.0105 10.1883 12.6477 10.11 12.2856 10.1397C11.8772 10.1335 11.471 10.1995 11.0856 10.3347C11.0843 10.353 11.0843 10.3714 11.0856 10.3897C11.0843 10.4005 11.0843 10.4114 11.0856 10.4222C11.0706 10.6247 11.0606 10.8297 11.0531 11.0347C11.0531 11.1272 11.0531 11.2147 11.0531 11.3047C11.1556 11.3197 11.2656 11.3347 11.3731 11.3447L11.6606 11.3697L11.7331 11.0597L11.7881 10.8272C11.7892 10.8172 11.7925 10.8076 11.7976 10.7989C11.8028 10.7903 11.8098 10.7829 11.8181 10.7772C11.846 10.7557 11.8773 10.7388 11.9106 10.7272C11.9908 10.6987 12.0755 10.6851 12.1606 10.6872C12.2393 10.6771 12.3193 10.6849 12.3947 10.71C12.47 10.7351 12.5387 10.7769 12.5956 10.8322C12.6736 10.9201 12.7148 11.0347 12.7106 11.1522C12.713 11.2433 12.6951 11.3339 12.6581 11.4172C12.5967 11.5405 12.4902 11.6355 12.3606 11.6822C12.1906 11.7496 12.0107 11.7885 11.8281 11.7972C11.7456 11.7972 11.6531 11.7972 11.5531 11.7972C11.5531 11.8672 11.5531 11.9422 11.5531 12.0172C11.5531 12.1322 11.5531 12.2522 11.5681 12.3622H11.9081C12.3931 12.3622 12.7456 12.5672 12.7456 12.9797C12.746 13.0467 12.7359 13.1133 12.7156 13.1772C12.7082 13.2032 12.6981 13.2283 12.6856 13.2522C12.6578 13.3102 12.6187 13.362 12.5706 13.4047C12.4156 13.5208 12.2237 13.5768 12.0306 13.5622C11.9446 13.5592 11.8599 13.5405 11.7806 13.5072C11.7703 13.5018 11.7612 13.4944 11.7539 13.4854C11.7466 13.4763 11.7412 13.4659 11.7381 13.4547L11.6781 13.2047L11.5981 12.8822L11.3956 12.9122C11.2506 12.9347 11.1081 12.9597 10.9756 12.9847C11.0106 13.3022 11.0481 13.6222 11.0931 13.9472C11.0931 13.9747 11.0931 14.0047 11.0931 14.0322C11.3653 14.0812 11.6416 14.1038 11.9181 14.0997C12.1126 14.1034 12.3071 14.0951 12.5006 14.0747C12.7842 14.0483 13.0571 13.953 13.2956 13.7972C13.3925 13.7234 13.4813 13.6396 13.5606 13.5472C13.5923 13.51 13.6216 13.4708 13.6481 13.4297C13.7108 13.3365 13.7549 13.2321 13.7781 13.1222C13.795 13.04 13.8034 12.9562 13.8031 12.8722C13.7999 12.6712 13.7234 12.4783 13.5881 12.3297Z",
    fill: "#843C1D"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5415 14.5014C15.9065 16.3414 15.0015 17.9189 13.7515 18.6539C13.2687 18.9425 12.7165 19.0946 12.154 19.0939C8.37898 19.0939 6.82398 12.5514 6.60148 8.15386C6.60148 8.08886 6.60148 8.02136 6.60148 7.95636C6.60148 7.65136 6.58398 7.35886 6.58398 7.07886H10.089L9.92148 7.71386C9.92148 7.71386 10.4415 20.1864 16.5415 14.5014Z",
    fill: "#6D6D6D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8557 18.5814C9.46824 16.9714 7.94324 10.0289 7.50074 7.07886H6.88574C6.88574 7.35886 6.88574 7.65136 6.90574 7.95636C6.90574 8.02136 6.90574 8.08886 6.90574 8.15636C7.12574 12.4864 8.63824 18.9064 12.2932 19.0889L13.8557 18.5814Z",
    fill: "#6D6D6D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7205 7.07886C17.7205 7.35886 17.7205 7.65136 17.7005 7.95636C17.7005 8.08386 17.7005 8.20636 17.6805 8.34886C15.2132 8.07846 12.7326 7.94742 10.2505 7.95636C7.93055 7.95636 6.96305 8.05386 6.57805 8.15386C6.57805 8.08886 6.57805 8.02136 6.57805 7.95636C6.57805 7.65136 6.56055 7.35886 6.56055 7.07886H17.7205Z",
    fill: "#6D6D6D"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4169 6.75073L18.3244 7.06073L18.1569 7.62573H6.12187L5.85938 6.75073H18.4169Z",
    fill: "url(#paint5_linear_1889_15016)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0191 19.4739L13.9166 19.5614C13.7737 19.6858 13.6408 19.8212 13.5191 19.9664C13.4289 20.0616 13.3697 20.1818 13.3491 20.3114C13.3513 20.6714 13.3025 21.03 13.2041 21.3764C13.1708 21.495 13.129 21.6112 13.0791 21.7239L13.0591 21.7739C13.0366 21.8164 13.0166 21.8614 12.9941 21.9014C12.7766 22.3089 12.4741 22.5614 12.1416 22.5614C11.9553 22.555 11.7777 22.4813 11.6416 22.3539C11.4638 22.1926 11.3231 21.9947 11.2291 21.7739C11.0296 21.3125 10.9307 20.8139 10.9391 20.3114C10.9391 20.0139 10.2666 19.4739 10.2666 19.4739V19.4589L10.5166 18.6414H13.7516L13.8816 19.0564L13.9766 19.3564L14.0091 19.4589L14.0191 19.4739Z",
    fill: "#C27337"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0141 19.4589H10.2666L10.5241 18.6414H13.7566L13.8866 19.0564L13.9816 19.3564L14.0141 19.4589Z",
    fill: "url(#paint6_linear_1889_15016)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6367 22.3539C11.2217 21.9989 10.9342 21.2189 10.9342 20.3114C10.9342 20.0139 10.2617 19.4739 10.2617 19.4739L10.5242 18.6414H13.7517C13.7517 18.6414 10.4742 18.7889 11.2142 19.5664C11.2617 19.6989 11.7867 19.7314 11.7867 19.7314C11.7867 19.7314 11.2867 21.6314 11.9517 21.7739C12.2717 21.8389 12.0017 22.1014 11.6367 22.3539Z",
    fill: "#6D6D6D"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2775 22.5617H11L11.2225 21.7742H13.0575L13.1125 21.9767L13.25 22.4567L13.2775 22.5617Z",
    fill: "url(#paint7_linear_1889_15016)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8031 28.1593H10.4756L11.0006 22.5593H13.2781L13.2881 22.6668L13.8031 28.1593Z",
    fill: "#C27337"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0166 19.4729L13.9141 19.5604C13.2216 19.5604 12.2516 19.5179 11.9141 19.5129C12.1041 19.5055 12.2936 19.4871 12.4816 19.4579C12.9622 19.3713 13.4329 19.2364 13.8866 19.0554L13.9816 19.3554L14.0141 19.4579L14.0166 19.4729Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2879 22.6703L11.7354 22.5628L13.2354 22.4578L13.2704 22.5628L13.2879 22.6703Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4194 6.75073L18.3269 7.06073L9.04688 6.75073H18.4194Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.3
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11.955 21.7742L11.7625 22.5617H11L11.2225 21.7742H11.955Z",
    fill: "#6D6D6D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7631 22.5593L11.4856 28.1593H11.4256H10.4756L11.0006 22.5593H11.7631Z",
    fill: "#6D6D6D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3175 7.62573H6.125L5.875 6.75073H8.105C7.8525 6.91073 7.155 7.54823 11.3175 7.62573Z",
    fill: "#6D6D6D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87437 7.62573H6.12187L5.85938 6.75073H6.48937L6.87437 7.62573Z",
    fill: "#6D6D6D"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8,
    d: "M10.3694 13.8195C10.3694 13.8195 9.18941 11.097 9.41941 8.46948H8.33691C8.33691 8.46948 8.61191 12.0495 10.3694 13.8195Z",
    fill: "url(#paint8_linear_1889_15016)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8,
    d: "M14.1289 15.1645C14.1346 15.1373 14.1346 15.1092 14.1289 15.082C14.1739 14.3095 14.1289 8.46948 14.1289 8.46948H17.2264C17.2264 8.46948 17.2814 14.672 14.1289 15.1645Z",
    fill: "url(#paint9_linear_1889_15016)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0234 15.2631C14.0709 14.4931 14.0234 8.65308 14.0234 8.65308H15.2509C15.2509 10.0131 15.1259 13.6406 14.0234 15.2631Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4741 6.75073H12.1416V7.62573H14.4741V6.75073Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6516 6.75073H15.0391V7.62573H15.6516V6.75073Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0599 7.51636H20.2949V8.17386H21.0599V7.51636Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0599 11.5984V12.7759C20.8246 13.0873 20.569 13.383 20.2949 13.6609V12.6834C20.5782 12.3425 20.834 11.9797 21.0599 11.5984Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8461 7.51636H21.4736V8.17386H21.8461V7.51636Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8461 9.85229V11.5323C21.7286 11.7548 21.5961 11.9673 21.4736 12.1773V10.8073C21.6173 10.4969 21.7417 10.178 21.8461 9.85229Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57613 7.51636H2.72363V8.17386H3.57613V7.51636Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57613 12.0315V13.1215C3.25918 12.7414 2.97405 12.3359 2.72363 11.909V10.4265C2.95052 10.99 3.23627 11.528 3.57613 12.0315Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4402 7.51636H4.0127V8.17386H4.4402V7.51636Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4402 13.1043V14.0193C4.2927 13.8868 4.1502 13.7493 4.0127 13.6093V12.6218C4.1477 12.7893 4.2902 12.9518 4.4402 13.1043Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9207 18.4054C16.8573 18.418 16.7928 18.4247 16.7282 18.4254C16.6304 18.4259 16.5332 18.4098 16.4407 18.3779C16.3799 18.0657 16.3481 17.7485 16.3457 17.4304C16.3816 17.5014 16.4261 17.5678 16.4782 17.6279L16.9207 18.4054Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5142 28.1595H12.5117L12.7542 23.782L13.5142 28.1595Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2287 28.1595H12.0762V23.782L12.2287 28.1595Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.2
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3105 20.1406C12.6205 20.3006 13.258 20.9956 12.6355 21.7056C12.5289 21.7356 12.4203 21.7582 12.3105 21.7731C12.547 21.7663 12.7821 21.8098 13.0005 21.9006C13.0434 21.9208 13.0836 21.9459 13.1205 21.9756L13.0655 21.7731L13.0855 21.7231C13.0855 21.7006 13.1055 21.6756 13.113 21.6531C13.1262 21.6254 13.1379 21.597 13.148 21.5681C13.1705 21.5081 13.1905 21.4431 13.2105 21.3756C13.309 21.0292 13.3578 20.6706 13.3555 20.3106C13.3761 20.1811 13.4354 20.0608 13.5255 19.9656C13.1317 20.0848 12.7221 20.1438 12.3105 20.1406Z",
    fill: "#6D6D6D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1889_15016",
    x1: 8.08098,
    y1: 12.6314,
    x2: -1.93152,
    y2: 13.7289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA4331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C27137"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1889_15016",
    x1: 6.48078,
    y1: 13.3264,
    x2: 0.275782,
    y2: 4.10386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C15F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C28A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1889_15016",
    x1: 15.2456,
    y1: 13.0281,
    x2: 22.6756,
    y2: 13.0281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA4331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C27137"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1889_15016",
    x1: 15.5052,
    y1: 12.9714,
    x2: 22.9352,
    y2: 12.9714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#C15F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C28A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1889_15016",
    x1: 6.56227,
    y1: 13.0864,
    x2: 17.7223,
    y2: 13.0864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C46E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C27337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C28A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1889_15016",
    x1: 5.85938,
    y1: 7.18823,
    x2: 18.4169,
    y2: 7.18823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C46E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C27337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C28A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1889_15016",
    x1: 10.2666,
    y1: 19.0489,
    x2: 14.0141,
    y2: 19.0489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C25439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C27337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C28A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1889_15016",
    x1: 11.09,
    y1: 22.1817,
    x2: 14.46,
    y2: 22.1392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3593F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C27337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C28A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1889_15016",
    x1: 8.33691,
    y1: 11.1445,
    x2: 10.3694,
    y2: 11.1445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1889_15016",
    x1: 14.1289,
    y1: 11.817,
    x2: 17.2264,
    y2: 11.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuara3New);
export default __webpack_public_path__ + "static/media/juara-3-new.23fa843501db9ba83ccfd988ef362bb1.svg";
export { ForwardRef as ReactComponent };